import { render } from "./Agenda.vue?vue&type=template&id=7bfd364e&scoped=true"
import script from "./Agenda.vue?vue&type=script&lang=js"
export * from "./Agenda.vue?vue&type=script&lang=js"

import "./Agenda.vue?vue&type=style&index=0&id=7bfd364e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7bfd364e"

export default script